import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsLandscape } from "@/hooks";
import { Box } from "@gemini/core";
export const ResponsiveImage = ({ image }) => {
    var _a;
    const isLandscape = useIsLandscape();
    return (_jsxs(Box, { as: "picture", display: "flex", alignItems: "center", justifyContent: "center", children: [(_a = image === null || image === void 0 ? void 0 : image.sources) === null || _a === void 0 ? void 0 : _a.map(({ media, url, key }) => (_jsx(Box, { as: "source", srcSet: url, media: media }, key))), _jsx(Box, { as: "img", src: image.url, alt: image.alt, objectFit: "contain", width: "auto", height: "auto", maxHeight: isLandscape ? "100dvh" : "calc(100dvh - 64px)", maxWidth: "100%", loading: "lazy" })] }, image.key));
};
